import { useEffect } from "react";

export const SITE_URL = "https://trueimpactpeptides.com";
export const SITE_NAME = "True Impact Peptides";
const DEFAULT_DESCRIPTION =
  "Premium Research Use Only peptides with batch-specific Certificates of Analysis and independent laboratory verification. Not for human consumption.";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(path) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", `${SITE_URL}${path}`);
}

export function applyPageMeta({ title, description, path }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Research Use Only Peptides`;
  const desc = description || DEFAULT_DESCRIPTION;
  document.title = fullTitle;
  setMeta("name", "description", desc);
  setMeta("property", "og:title", fullTitle);
  setMeta("property", "og:description", desc);
  setMeta("property", "og:url", `${SITE_URL}${path || window.location.pathname}`);
  setCanonical(path || window.location.pathname);
}

export function usePageMeta(title, description, path) {
  useEffect(() => {
    applyPageMeta({ title, description, path });
  }, [title, description, path]);
}

export function useProductJsonLd(product) {
  useEffect(() => {
    if (!product) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "product-jsonld";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      name: `${product.name} ${product.strength}`,
      description: product.seo_description || product.description,
      sku: product.sku,
      brand: { "@type": "Brand", name: SITE_NAME },
      url: `${SITE_URL}/product/${product.slug}`,
      offers: {
        "@type": "Offer",
        priceCurrency: "USD",
        price: product.price,
        availability: product.stock_quantity > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        url: `${SITE_URL}/product/${product.slug}`,
      },
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById("product-jsonld")?.remove();
    };
  }, [product]);
}
